module.exports = __webpack_public_path__ + "img/fork2.c5e8ad9b.png";